import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=ea76a770"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea76a770')) {
      api.createRecord('ea76a770', component.options)
    } else {
      api.reload('ea76a770', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=ea76a770", function () {
      api.rerender('ea76a770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/account/views/irs/sii/Settings.vue"
export default component.exports